import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { ArrowLeft } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      
      <div className="flex-grow flex items-center justify-center p-6">
        <div className="text-center max-w-md animate-fade-in">
          <h1 className="text-8xl font-display font-bold text-barbecue-600 mb-6">404</h1>
          <h2 className="heading-lg mb-4">Stran ni najdena</h2>
          <p className="paragraph mb-8">
            Oprostite, strani, ki jo iščete, ni mogoče najti. Morda je bila premaknjena ali izbrisana.
          </p>
          <Link to="/" className="btn-primary inline-flex items-center">
            <ArrowLeft className="mr-2" size={18} />
            Nazaj na domačo stran
          </Link>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default NotFound;